<template>
  <div class="d-flex align-items-center user_question_container mb-3" :class="[
    design == 1 ? 'flex-row-reverse' : ''
  ]">
    <div>
      <em class="primaryicon-user-icon" :style="{ color: primaryColor }"></em>
    </div>
    <div class="user_question">
      <p v-if="userinput.customUIUserResponse" class="user_response mb-0">
        {{
          userinput.customUIUserResponse
            ? userinput.customUIUserResponse
            : userinput.EventLabel
        }}
      </p>
      <p v-else class="user_response mb-0">
        {{ userinput.UserResponse ? userinput.UserResponse : userinput.EventLabel }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      primaryColor: window.primaryColor
    }
  },
  props: {
    question: {
      type: String,
      default: '',
    },
    userinput: {
      default: '',
      required: false,
    },
    requesttime: {
      default: '',
      required: false,
    },
    index: {
      default: '',
      required: false,
    },
    design: {
      default: null,
      required: false,
    }
  }
}
</script>
<style scoped>
.user_question_container {
  gap: 13px;
}

.user_question_container em {
  background: #fff;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 23px;
}

.user_question {
  background-color: #fff;
  padding: 15px 20px;
  border-radius: 10px 10px 10px 0px;
  display: inline-block;
}

.user_question p {
  font-weight: 500;
}
</style>
